<!-- <div class="drawer-backdrop" *ngIf="isOpen$ | async" (click)="close()"></div> -->
<div class="drawer-backdrop" [class.open]="isOpen$ | async" (click)="close()"></div>

<div class="drawer-container" [class.open]="isOpen$ | async">
  <div class="drawer-header">
    <div class="logo">
      <svg width="133" height="22" viewBox="0 0 133 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_94_1501)">
          <mask id="mask0_94_1501" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="133"
            height="22">
            <path d="M132.823 0H0V21.162H132.823V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_94_1501)">
            <path
              d="M9.65657 21.161C7.9228 21.1884 6.21397 20.7458 4.71157 19.88C3.2387 19.0148 2.04191 17.749 1.26057 16.23C0.382202 14.4861 -0.0510054 12.552 -0.000425437 10.6C-0.0541817 8.63366 0.379001 6.68451 1.26057 4.92602C2.0396 3.40485 3.23689 2.13782 4.71157 1.27402C6.21568 0.413204 7.92377 -0.026858 9.65657 1.74766e-05C11.3857 -0.0277643 13.0902 0.412431 14.5896 1.27402C16.0583 2.14278 17.2518 3.40871 18.0326 4.92602C18.9185 6.68316 19.3539 8.63292 19.2996 10.6C19.3524 12.5588 18.9166 14.4998 18.0316 16.248C17.2494 17.7625 16.0561 19.0258 14.5886 19.893C13.0892 20.7547 11.3847 21.1946 9.65557 21.166M9.65557 17.433C10.6479 17.4523 11.6232 17.1736 12.4556 16.633C13.2997 16.0559 13.9594 15.2476 14.3556 14.305C14.8445 13.1322 15.0793 11.8692 15.0446 10.599C15.0795 9.32206 14.8448 8.05208 14.3556 6.87202C13.9606 5.92679 13.3008 5.1159 12.4556 4.53702C11.6232 3.99649 10.6479 3.71783 9.65557 3.73702C8.66354 3.71997 7.68886 3.99845 6.85557 4.53702C6.00777 5.11306 5.34724 5.92481 4.95557 6.87202C4.46976 8.05334 4.2361 9.32314 4.26957 10.6C4.23604 11.8674 4.46836 13.1278 4.95157 14.3C5.34446 15.2446 6.00487 16.0538 6.85157 16.628C7.68486 17.1666 8.65954 17.4451 9.65158 17.428"
              fill="#001F58" />
            <path
              d="M32.9895 20.8451L27.4785 0.317139H32.0115L34.4225 10.4851C34.6158 11.3305 34.7975 12.1891 34.9675 13.0611C35.1375 13.9331 35.3042 14.8058 35.4675 15.6791C35.6282 16.5511 35.7822 17.4178 35.9295 18.2791H35.0995C35.2648 17.4165 35.4315 16.5498 35.5995 15.6791C35.7675 14.8085 35.9445 13.9358 36.1305 13.0611C36.3132 12.1891 36.5102 11.3305 36.7215 10.4851L39.2585 0.317139H43.5845L46.1055 10.4851C46.3168 11.3305 46.5142 12.1891 46.6975 13.0611C46.8809 13.9331 47.0575 14.8058 47.2275 15.6791C47.3975 16.5511 47.5698 17.4178 47.7445 18.2791H46.8905C47.0465 17.4165 47.2049 16.5498 47.3655 15.6791C47.5262 14.8085 47.6928 13.9358 47.8655 13.0611C48.0402 12.1891 48.2192 11.3305 48.4025 10.4851L50.8165 0.317139H55.3635L49.8395 20.8451H45.0865L42.2195 9.80014C41.9902 8.90947 41.7722 7.92447 41.5655 6.84514C41.3589 5.76581 41.1225 4.57847 40.8565 3.28314H41.9715C41.6962 4.56914 41.4598 5.74947 41.2625 6.82414C41.0652 7.89881 40.8472 8.89081 40.6085 9.80014L37.7425 20.8451H32.9895Z"
              fill="#001F58" />
            <path
              d="M65.3633 20.8451V0.317139H69.8833L76.4543 10.7881C76.683 11.1561 76.956 11.6198 77.2733 12.1791C77.5906 12.7385 77.924 13.3448 78.2733 13.9981C78.6233 14.6501 78.9586 15.3068 79.2793 15.9681L78.8103 16.8231C78.7743 16.1598 78.7409 15.4178 78.7103 14.5971C78.6796 13.7765 78.6543 12.9868 78.6343 12.2281C78.611 11.4701 78.5993 10.8608 78.5993 10.4001V0.317139H82.8563V20.8451H78.3283L72.3623 11.3531C72.0776 10.8945 71.747 10.3431 71.3703 9.69914C70.9936 9.05514 70.5826 8.32514 70.1373 7.50914C69.6913 6.69114 69.2113 5.80914 68.6973 4.86314L69.3863 4.49114C69.453 5.49114 69.5013 6.43981 69.5313 7.33714C69.5613 8.23447 69.5839 9.02414 69.5993 9.70614C69.6133 10.3908 69.6203 10.9351 69.6203 11.3391V20.8451H65.3633Z"
              fill="#001F58" />
            <path d="M94.4834 20.8451V0.317139H98.7124V17.2491H107.943V20.8491L94.4834 20.8451Z" fill="#001F58" />
            <path
              d="M121.195 20.8451V13.1581L113.591 0.317139H118.467L121.953 6.53014C122.273 7.10881 122.581 7.68747 122.876 8.26614C123.17 8.84481 123.464 9.45114 123.758 10.0851H122.835C123.119 9.45114 123.403 8.84481 123.689 8.26614C123.974 7.68747 124.278 7.10881 124.6 6.53014L127.973 0.317139H132.823L125.342 13.1581V20.8451H121.195Z"
              fill="#001F58" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_94_1501">
            <rect width="132.823" height="21.162" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <button class="close-btn" (click)="close()">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_115_1558)">
          <path d="M1.25293 1.25293L20.747 20.747" stroke="#001F58" stroke-width="2" stroke-linecap="round" />
        </g>
        <g clip-path="url(#clip1_115_1558)">
          <path d="M20.747 1.25293L1.25293 20.747" stroke="#001F58" stroke-width="2" stroke-linecap="round" />
        </g>
        <defs>
          <clipPath id="clip0_115_1558">
            <rect width="22" height="22" fill="white" />
          </clipPath>
          <clipPath id="clip1_115_1558">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>
  <div class="drawer-body">
    <div class="list-header">My Account</div>
    <ul>
      @for (menu of sidebarMenuMyAccount(); track menu.id) {
      <li (click)="close()"
        routerLink="{{menu.route}}">
        <div class="text">{{menu.name}}</div>
      </li>
      }
    </ul>
    <div class="list-header">Accounts I Manage</div>
    <ul>
      <li>My Family</li>
      @for (menu of sidebarMenuOtherAccount(); track menu.id) {
      <li (click)="close()"
        routerLink="{{menu.route}}">
        <div class="text">{{menu.name}}</div>
      </li>
      }
    </ul>
  </div>
</div>